import React from 'react';

// Where the person's bank is. Stripe fixes an account's country when it's
// created, and an account made without one is a US account, so this has to be
// asked before payout setup starts. Outside the US, Stripe pays out in the
// local currency.
export const PAYOUT_COUNTRIES: { code: string; label: string }[] = [
  { code: 'US', label: 'United States' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'CA', label: 'Canada' },
  { code: 'IE', label: 'Ireland' },
  { code: 'AU', label: 'Australia' },
  { code: 'NZ', label: 'New Zealand' },
  { code: 'DE', label: 'Germany' },
  { code: 'FR', label: 'France' },
  { code: 'ES', label: 'Spain' },
  { code: 'IT', label: 'Italy' },
  { code: 'NL', label: 'Netherlands' },
];

// The account's own country when there is one; otherwise the browser's region.
export function defaultPayoutCountry(accountCountry?: string | null): string {
  const known = (c?: string | null) => (c && PAYOUT_COUNTRIES.some(p => p.code === c) ? c : null);
  if (known(accountCountry)) return accountCountry as string;
  try {
    const region = new Intl.Locale(navigator.language).maximize().region;
    if (known(region)) return region as string;
  } catch { /* old browser */ }
  return 'US';
}

export function PayoutCountrySelect({ value, onChange, disabled }: { value: string; onChange: (c: string) => void; disabled?: boolean }) {
  return (
    <label className="flex items-center gap-2" style={{ fontSize: 13, color: 'var(--hj-ink-2)' }}>
      Bank country
      <select
        value={value}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        style={{ fontSize: 13, padding: '6px 8px', borderRadius: 8, border: '1px solid var(--hj-hairline)', background: 'var(--hj-surface-1)', color: 'var(--hj-ink)' }}
      >
        {PAYOUT_COUNTRIES.map(c => <option key={c.code} value={c.code}>{c.label}</option>)}
      </select>
    </label>
  );
}
